/* OVSS Club : carte qui suit la souris, nom qui s'écrit sur la carte, copier un code, carrousel des statuts. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tilt(root) {
    if (reduce) return;
    root.querySelectorAll('[data-ovc-tilt]').forEach(function (c) {
      if (c.dataset.ovcReady) return;
      c.dataset.ovcReady = '1';
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        c.style.setProperty('--ry', (x * 14) + 'deg');
        c.style.setProperty('--rx', (-y * 10) + 'deg');
        c.style.setProperty('--sx', (x * 120) + '%');
      });
      c.addEventListener('pointerleave', function () {
        c.style.setProperty('--ry', '0deg');
        c.style.setProperty('--rx', '0deg');
        c.style.setProperty('--sx', '-30%');
      });
    });
  }

  function liveName(root) {
    var target = root.querySelector('[data-ovc-card-name]');
    if (!target) return;
    var fn = document.querySelector('input[name="customer[first_name]"]');
    var ln = document.querySelector('input[name="customer[last_name]"]');
    if (!fn && !ln) return;
    function upd() {
      var v = ((fn ? fn.value : '') + ' ' + (ln ? ln.value : '')).trim();
      target.textContent = v || target.dataset.empty || '';
    }
    [fn, ln].forEach(function (i) { if (i) i.addEventListener('input', upd); });
    upd();
  }

  function copy(root) {
    root.querySelectorAll('[data-ovc-copy]').forEach(function (b) {
      if (b.dataset.ovcReady) return;
      b.dataset.ovcReady = '1';
      var label = b.textContent;
      b.addEventListener('click', function () {
        var txt = b.dataset.ovcCopy;
        function done(t) { b.textContent = t; setTimeout(function () { b.textContent = label; }, 1600); }
        function fallback() {
          var el = b.parentNode.querySelector('[data-ovc-code]');
          if (!el) return done('Sélectionne le code');
          var r = document.createRange(); r.selectNodeContents(el);
          var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
          done('Sélectionné');
        }
        try { navigator.clipboard.writeText(txt).then(function () { done('Copié'); }, fallback); } catch (e) { fallback(); }
      });
    });
  }

  function deck(root) {
    root.querySelectorAll('[data-ovc-deck]').forEach(function (d) {
      if (d.dataset.ovcReady) return;
      d.dataset.ovcReady = '1';
      var cards = [].slice.call(d.querySelectorAll('.ovc-card'));
      var wrap = d.closest('[data-ovc-car]');
      var label = wrap ? wrap.querySelector('[data-ovc-tierlbl]') : null;
      var i = parseInt(d.dataset.start || '0', 10) || 0;
      function lay() {
        cards.forEach(function (c, k) {
          var off = k - i;
          c.style.setProperty('--x', (off * 28) + '%');
          c.style.setProperty('--s', off === 0 ? 1 : 0.82);
          c.style.setProperty('--o', Math.abs(off) > 1 ? 0 : 1);
          c.style.setProperty('--br', off === 0 ? 1 : 0.55);
          c.style.zIndex = 10 - Math.abs(off);
          c.setAttribute('aria-hidden', off === 0 ? 'false' : 'true');
        });
        if (label && cards[i]) label.innerHTML = cards[i].dataset.label || (cards[i].parentNode && cards[i].parentNode.dataset.label) || '';
      }
      if (wrap) {
        var p = wrap.querySelector('[data-ovc-prev]');
        var n = wrap.querySelector('[data-ovc-next]');
        if (p) p.addEventListener('click', function () { i = Math.max(0, i - 1); lay(); });
        if (n) n.addEventListener('click', function () { i = Math.min(cards.length - 1, i + 1); lay(); });
      }
      var sx = null;
      d.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      d.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) { i = dx < 0 ? Math.min(cards.length - 1, i + 1) : Math.max(0, i - 1); lay(); }
        sx = null;
      });
      lay();
    });
  }

  function init(root) { root = root || document; tilt(root); liveName(root); copy(root); deck(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
